import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import loadable from "@loadable/component";
import { useTranslation } from "@i18n";
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import stl from "./PaymentTabBox.module.css";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { BottomSheet } from "@componentsShared/BottomSheet";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import useBoolean from "@hooks/useBoolean";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import useHelpers from "@hooks/useHelpers";
import useSubmissionSource from "@hooks/useSubmissionSource";
import EligibilityComponent from "@componentsShared/EligibilityComponent/EligibilityComponent";
import CarColorVariation from "@/pages/post/PostViewComponents/components/CarColorVariation/CarColorVariation";
var fallback = {
  fallback: null
};
var PaymentTabBoxPopup = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "PaymentTabBoxPopup";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "PaymentTabBoxPopup" */"./PaymentTabBoxPopup");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./PaymentTabBoxPopup");
    }
    return eval('require.resolve')("./PaymentTabBoxPopup");
  }
}, fallback);
var CallUsBy = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "CallUsBy";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "CallUsBy" */"./CallUsBy");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./CallUsBy");
    }
    return eval('require.resolve')("./CallUsBy");
  }
}, fallback);
var PaymentTabBox = function PaymentTabBox(_ref) {
  var _priceSection$vat_pri, _priceSection$old_pri, _priceSection$old_pri2, _priceSection$old_pri3, _priceSection$finance, _priceSection$finance2, _priceSection$finance3, _details$color_varian, _details$details_card, _details$details_card2, _details$details_card3, _details$details_card4;
  var priceSection = _ref.priceSection,
    postId = _ref.postId,
    postTitle = _ref.postTitle,
    reserved = _ref.reserved,
    g4_data = _ref.g4_data,
    footer_section = _ref.footer_section,
    isUsed = _ref.isUsed,
    car_condition = _ref.car_condition,
    details = _ref.details,
    gallery = _ref.gallery;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _useState = useState(false),
    showNumbers = _useState[0],
    setShowNumbers = _useState[1];
  var _useState2 = useState(false),
    showPaymentTabBoxPopup = _useState2[0],
    setShowPaymentTabBoxPopup = _useState2[1];
  var _useBoolean = useBoolean(),
    isCalculatorOpen = _useBoolean.value,
    openCalculator = _useBoolean.setTrue,
    closeCalculator = _useBoolean.setFalse;
  var _useState3 = useState(false),
    hasInteracted = _useState3[0],
    setHasInteracted = _useState3[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateToHard = _useHelpers.navigateToHard;
  var _useSubmissionSource = useSubmissionSource(),
    setSubmissionSource = _useSubmissionSource.setSubmissionSource;
  var showImagesDisclaimer = function showImagesDisclaimer() {
    if ((gallery === null || gallery === void 0 ? void 0 : gallery.images.length) > 0) {
      var _gallery$images$filte, _gallery$images$filte2;
      var exteriorImages = (_gallery$images$filte = gallery.images.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "exterior";
      })) === null || _gallery$images$filte === void 0 ? void 0 : _gallery$images$filte.length;
      var interiorImages = (_gallery$images$filte2 = gallery.images.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "interior";
      })) === null || _gallery$images$filte2 === void 0 ? void 0 : _gallery$images$filte2.length;
      return exteriorImages < 5 || interiorImages < 5;
    }
    return false;
  };
  var handleFirstInteraction = function handleFirstInteraction(_ref2) {
    var field = _ref2.field;
    if (hasInteracted) {
      setHasInteracted(false);
      trackEvents("finance_calculator_interact", _objectSpread(_objectSpread({}, g4_data), {}, {
        post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext,
        field_interaction: field
      }));
    }
  };
  useEffect(function () {
    if (isCalculatorOpen) {
      setHasInteracted(true);
    } else {
      setHasInteracted(false);
    }
  }, [isCalculatorOpen]);
  var handleCalculatorClick = function handleCalculatorClick() {
    openCalculator();
    trackEvents("finance_calculator_open", _objectSpread(_objectSpread({}, g4_data), {}, {
      post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.newContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.newPriceFlx
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.newCahsPay
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.NewPriceTitle
  }, t("سعر الكاش", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.NewPriceHolder
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$vat_pri = priceSection.vat_price) === null || _priceSection$vat_pri === void 0 ? void 0 : _priceSection$vat_pri.text, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency)), (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$old_pri = priceSection.old_price) === null || _priceSection$old_pri === void 0 ? void 0 : _priceSection$old_pri.text_with_vat) && /*#__PURE__*/React.createElement("div", {
    className: stl.NewOldPriceHolder
  }, /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$old_pri2 = priceSection.old_price) === null || _priceSection$old_pri2 === void 0 ? void 0 : _priceSection$old_pri2.text_with_vat, ((_priceSection$old_pri3 = priceSection.old_price) === null || _priceSection$old_pri3 === void 0 ? void 0 : _priceSection$old_pri3.text_with_vat) && /*#__PURE__*/React.createElement("span", null, " ", priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency))), /*#__PURE__*/React.createElement("p", {
    className: stl.newCashNote
  }, /*#__PURE__*/React.createElement("img", {
    width: "14px",
    height: "14px",
    src: CDN_LINK + "/assets/images/GreyCheck.svg",
    alt: "tik"
  }), /*#__PURE__*/React.createElement("span", null, t("السعر يشمل الضريبة المضافة", {
    ns: "web_post_view"
  }))))), (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance = priceSection.finance_price) === null || _priceSection$finance === void 0 ? void 0 : _priceSection$finance.text) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.newKastContainer,
    onClick: function onClick() {
      return handleCalculatorClick();
    }
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.NKTitle
  }, t("يبدأ القسط من", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.NKPrice
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance2 = priceSection.finance_price) === null || _priceSection$finance2 === void 0 ? void 0 : _priceSection$finance2.text, /*#__PURE__*/React.createElement("span", {
    className: "text-lg"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, t("ريال", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, t("/ شهرياً", {
    ns: "web_post_view"
  })))), reserved == 0 && /*#__PURE__*/React.createElement("strong", {
    className: stl.NewOpenKastDetails
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    width: 17,
    height: 17,
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/arithmetic.svg",
    alt: "arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.underline
  }, t("احسب التمويل", {
    ns: "web_post_view"
  }))))), (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance3 = priceSection.finance_price) === null || _priceSection$finance3 === void 0 ? void 0 : _priceSection$finance3.text) && showPaymentTabBoxPopup && /*#__PURE__*/React.createElement(PaymentTabBoxPopup, {
    priceSection: priceSection,
    onClose: function onClose() {
      return setShowPaymentTabBoxPopup(false);
    },
    isUsed: isUsed
  })), reserved == 0 && /*#__PURE__*/React.createElement(EligibilityComponent, {
    design: "button",
    postID: postId,
    postCondition: isUsed ? "0" : "1",
    entryPoint: "car_details_page"
  }), (details === null || details === void 0 ? void 0 : (_details$color_varian = details.color_variants) === null || _details$color_varian === void 0 ? void 0 : _details$color_varian.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CarColorVariation, {
    colors: details === null || details === void 0 ? void 0 : details.color_variants,
    onColorClick: function onColorClick(color) {
      var _color$name_en;
      trackEvents("car_color_selected", {
        referral_location: "post_details",
        post_id: postId,
        selected_color: (_color$name_en = color === null || color === void 0 ? void 0 : color.name_en) !== null && _color$name_en !== void 0 ? _color$name_en : '',
        post_make: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_make,
        post_model: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_model
      });
      navigateToHard("/cardetail/".concat(color.post_id));
    },
    currentColorCode: details === null || details === void 0 ? void 0 : (_details$details_card = details.details_card) === null || _details$details_card === void 0 ? void 0 : (_details$details_card2 = _details$details_card.exterior_color) === null || _details$details_card2 === void 0 ? void 0 : _details$details_card2.code,
    currentColorName: details === null || details === void 0 ? void 0 : (_details$details_card3 = details.details_card) === null || _details$details_card3 === void 0 ? void 0 : (_details$details_card4 = _details$details_card3.exterior_color) === null || _details$details_card4 === void 0 ? void 0 : _details$details_card4.name,
    showDisclaimer: showImagesDisclaimer()
  })), reserved == 1 ? /*#__PURE__*/React.createElement("div", {
    className: stl.reservedCarBox
  }, /*#__PURE__*/React.createElement("strong", null, t("هذه السيارة محجوزة", {
    ns: "web_post_view"
  })), !showNumbers && /*#__PURE__*/React.createElement("span", {
    className: ["greenTextBtn", "m-hide"].join(" "),
    onClick: function onClick() {
      setShowNumbers(true);
    }
  }, t("تواصل مع مندوب المبيعات", {
    ns: "web_post_view"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/pre-checkout/".concat(postId)),
    id: "BuyNow",
    className: ["greenBtn", stl.buyLinkPPt, "m-hide"].join(" "),
    onClick: function onClick() {
      cashCheckout1Event("checkout_lead", g4_data);
      sessionStorage.removeItem("installment-calculator-".concat(postId));
      setSubmissionSource('car_detail');
      trackEvents("book_car", _objectSpread(_objectSpread({}, g4_data), {}, {
        post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext,
        inventory_type_string: g4_data === null || g4_data === void 0 ? void 0 : g4_data.inventory_type_string
      }));
    }
  }, t("المتابعة", {
    ns: "web_post_view"
  })), !showNumbers && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowNumbers(true);
    },
    className: ["greenTextBtn", stl.buyLinkPPt, "m-hide"].join(" ")
  }, t("اتصل بنا للحجز", {
    ns: "web_post_view"
  }))), showNumbers && /*#__PURE__*/React.createElement(CallUsBy, {
    postId: postId,
    footer_section: footer_section,
    postTitle: postTitle,
    onClose: function onClose() {
      return setShowNumbers(false);
    }
  })), reserved == 0 && /*#__PURE__*/React.createElement(BottomSheet, {
    open: isCalculatorOpen,
    onOpen: openCalculator,
    onClose: closeCalculator,
    screens: [{
      title: t('احسب قيمة التمويل', {
        ns: 'web_post_view'
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
        carCondition: car_condition,
        cashPrice: priceSection === null || priceSection === void 0 ? void 0 : priceSection.vat_price.text.replace(/,/g, ""),
        onClose: closeCalculator,
        onInteraction: handleFirstInteraction
      })
    }, {
      title: t('شروط التمويل', {
        ns: "web_post_view"
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null)
    }]
  }));
};
export default PaymentTabBox;